import { FaPodcast } from "react-icons/fa";
import { BASE_FRONT_END_URL } from "../../../../utils/appConstant";

function PodcastCitations({ citation, onCitationClick }: any) {
    //   console.log("citation in podcast: ", citation);
    function onCitationClicked(citations: any): void {
        if (onCitationClick) {
            onCitationClick(citations);
        }
    }

    function getStartTimeFromUrl(url: string): number | null {
        try {
            const urlObj = new URL(url);
            const params = new URLSearchParams(urlObj.search);
            const startTimeStr = params.get("start");

            if (!startTimeStr) {
                return null;
            }

            const startTime = parseInt(startTimeStr, 10);
            return isNaN(startTime) ? null : startTime;
        } catch (error) {
            return null;
        }
    }

    function convertSecondsToMinutesSeconds(seconds: number): string {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
    }

    function getStartTimeInMinutesSeconds(url: string): string | null {
        const seconds = getStartTimeFromUrl(url);
        if (seconds === null) {
            return null;
        }
        return convertSecondsToMinutesSeconds(seconds);
    }

    return (
        <div>
            <a
                target="_blank"
                rel="noopener noreferrer"
                href={BASE_FRONT_END_URL + "podcast/summary/" + citation.citation.substring(0, citation.citation.lastIndexOf("."))}
                className="cursor-pointer text-blue-600 hover:underline"
            >
                {citation.title}
                &nbsp;
                <FaPodcast className="inline" title="Software People Stories Podcast Summary" />
            </a>
        </div>
    );
}

export default PodcastCitations;
